import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Card, Table } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const ReportList = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [municipalityList, setMunicipalityList] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [circleList, setcircleList] = useState([]);
  const [municipalityData, setMunicipalityData] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    district_id: "",
    subdivision_id: "",
    circle_id: "",
    municipality_id: "",
    school_id: "",
    class_id: "",
  });

  const fetchDistricts = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/districtMasterList`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setDistrictList(res.data.data || []);
    } catch (err) {
      handle401(err);
    }
  };



const fetchSubDivisions = async (districtId = "") => {
  try {
const token = localStorage.getItem("token");

    // ✅ If userTypeId is 2, override districtId with value from localStorage
    if (userTypeId === 2) {
      districtId = localStorage.getItem("districtId") || "";
    }

    const res = await axios.post(
      `${BASE_URL}/subDivisionList`,
      { district_id: districtId },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setSubDivisionList(res.data.data || []);
  } catch (err) {
    handle401(err);
  }
};


const handleDistrictChange = (e) => {
  const value = e.target.value;

  setFilters((prev) => ({
    ...prev,
    district_id: value,
    subdivision_id: "",
    circle_id: "",
    municipality_id: "",
    school_id: "",
  }));

  fetchSubDivisions(value);
  loadMunicipalities(value);

  loadSchools();
};




  const userTypeId = Number(localStorage.getItem("userTypeId"));
  const muniName = localStorage.getItem("name");

  const [loading, setLoading] = useState(false);


//   const fetchCircleList = async (subDivisionId = "") => {
//   try {
// const token = localStorage.getItem("token");

//     const payload =
//       userTypeId === 2
//         ? {
//             district_id: localStorage.getItem("districtId"), // ✅ ONLY district
//           }
//         : {
//             district_id: filters.district_id,
//             sub_division_id: subDivisionId, // ✅ admin needs subdivision
//           };

//     const res = await axios.post(
//       `${BASE_URL}/circleMasterList`,
//       payload,
//       {
//         headers: { Authorization: `Bearer ${token}` },
//       }
//     );

//     setcircleList(res.data?.data || []);
//   } catch (err) {
//     console.log("Circle load error:", err);
//     Swal.fire("Error", "Failed to load circles", "error");
//   }
// };


const fetchCircleList = async (subDivisionId = "") => {
  try {
const token = localStorage.getItem("token");

    let payload = {};

    if (userTypeId === 2) {

    return
    } else {
      // ✅ Admin
      payload = {
        district_id: filters.district_id || "",
        sub_division_id: subDivisionId || "",
      };
    }

    const res = await axios.post(`${BASE_URL}/circleMasterList`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setcircleList(res.data?.data || []);
  } catch (err) {
    console.log("Circle load error:", err);
    Swal.fire("Alert", "Failed to load circles", "error");
  }
};


  const municipalityId =
    userTypeId === 1
      ? filters.municipality_id
      : localStorage.getItem("municipality_id");

  useEffect(() => {
    loadMunicipalities();
    loadClasses();
    fetchDistricts();

    // ✅ Only auto-load reports for NON userTypeId 1
    if (userTypeId !== 1) {
      loadReports(1);
    }
  }, [userTypeId]);

  const today = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

//   const loadMunicipalities = async () => {
//     try {
//   const token = localStorage.getItem("token");
//       const res = await axios.post(
//         `${BASE_URL}/municipalityList`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       setMunicipalityList(res.data.data || []);
//     } catch (err) {
//       handle401(err);
//     }
//   };
const loadMunicipalities = async (districtId = "") => {
  try {
const token = localStorage.getItem("token");

    const payload = userTypeId === 1 ? { district_id: districtId } : {};

    const res = await axios.post(
      `${BASE_URL}/municipalityList`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setMunicipalityList(res.data.data || []);
  } catch (err) {
    handle401(err);
  }
};



//   const loadSchools = async () => {
//     try {
//   const token = localStorage.getItem("token");

//       if (!municipalityId) {
//         setSchoolList([]);
//         return;
//       }

//       const res = await axios.post(
//         `${BASE_URL}/schoolList`,
//         { municipality_id: municipalityId },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );

//       setSchoolList(res.data.data || []);
//     } catch (err) {
//       handle401(err);
//     }
//   };


const loadSchools = async () => {
  try {
const token = localStorage.getItem("token");

    let payload = {};

    if (userTypeId === 2) {
      // ✅ ULB: ONLY municipality_id (+ circle optional)
      payload = {
        municipality_id: localStorage.getItem("municipality_id"),
        circle_id: filters.circle_id || "",
      };
    } else {
      // ✅ Admin
      payload = {
        district_id: filters.district_id || "",
        subdivision_id: filters.subdivision_id || "",
        circle_id: filters.circle_id || "",
        municipality_id: filters.municipality_id || "",
      };
    }

    const res = await axios.post(
      `${BASE_URL}/schoolList`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setSchoolList(res.data.data || []);
  } catch (err) {
    handle401(err);
  }
};



  const loadClasses = async () => {
    try {
  const token = localStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/classList`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClassList(res.data.data.class_list || []);
    } catch (err) {
      handle401(err);
    }
  };






 useEffect(() => {
  if (userTypeId === 2) {
    loadSchools(); // municipality already from localStorage
  } else {
    if (filters.municipality_id) loadSchools();
    else setSchoolList([]);
  }
}, [
  userTypeId,
  filters.municipality_id,
  filters.circle_id,
  filters.subdivision_id,
  filters.district_id,
]);


useEffect(() => {
  if (userTypeId === 2) {
    fetchSubDivisions();
  }
}, [userTypeId]);




  useEffect(() => {
    setFilters((prev) => ({ ...prev, school_id: "" }));

    const muniId =
      userTypeId === 1
        ? filters.municipality_id
        : localStorage.getItem("municipality_id");

    if (muniId) {
      loadSchools(muniId);
    } else {
      setSchoolList([]);
    }
  }, [filters.municipality_id, userTypeId]);

//   const loadReports = async (
//     pageNo = 1,
//     pageSize = perPage,
//     filterOverride = filters,
//   ) => {
//     try {
//       setLoading(true);
//   const token = localStorage.getItem("token");

//       const payload = {
//         district_id: filterOverride.district_id || "",
//         subdivision_id: filterOverride.subdivision_id || "",
//         municipality_id:
//           userTypeId === 1
//             ? filterOverride.municipality_id || ""
//             : localStorage.getItem("municipality_id") || "",
//         circle_id: filterOverride.circle_id || "",
//         school_id: filterOverride.school_id || "",
//         class_id: filterOverride.class_id || "",
//         section_id: "",
//         page: pageNo,
//         per_page: pageSize,
//       };

//       const res = await axios.post(
//         `${BASE_URL}/measurementsCountReport`,
//         payload,
//         { headers: { Authorization: `Bearer ${token}` } },
//       );

//       setReports(res.data.data || []);
//       setPage(pageNo);
//       setTotalRecords(res.data.total_records || 0);
//       setTotalPages(Math.ceil((res.data.total_records || 0) / pageSize));
//     } catch (err) {
//       handle401(err);
//     } finally {
//       setLoading(false);
//     }
//   };


const loadReports = async (
  pageNo = 1,
  pageSize = perPage,
  filterOverride = filters,
) => {
  try {
    setLoading(true);
const token = localStorage.getItem("token");

    // 1️⃣ Main report payload
    const payload = {
      district_id: filterOverride.district_id || "",
      subdivision_id: filterOverride.subdivision_id || "",
      municipality_id:
        userTypeId === 1
          ? filterOverride.municipality_id || ""
          : localStorage.getItem("municipality_id") || "",
      circle_id: filterOverride.circle_id || "",
      school_id: filterOverride.school_id || "",
      class_id: filterOverride.class_id || "",
      section_id: "",
      page: pageNo,
      per_page: pageSize,
    };

    // 2️⃣ Fetch main report
    const res = await axios.post(
      `${BASE_URL}/measurementsCountReport`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } },
    );

    setReports(res.data.data || []);
    setPage(pageNo);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(Math.ceil((res.data.total_records || 0) / pageSize));

    // 3️⃣ If userTypeId === 1 and municipality is selected, fetch municipality-wise summary
    if (userTypeId === 1 && filterOverride.municipality_id) {
  const muniRes = await axios.post(
    `${BASE_URL}/municipalityWiseMeasurementCountReport`,
    { municipality_id: filterOverride.municipality_id },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  // ✅ Use first element of the array
  setMunicipalityData(muniRes.data.data?.[0] || null);
} else {
  setMunicipalityData(null);
}

  } catch (err) {
    handle401(err);
  } finally {
    setLoading(false);
  }
};

  const handle401 = (err) => {
    if (err.response?.status === 401) {
      localStorage.clear();

      if (userTypeId === 1) {
        navigate("/suda/login");
      } else if (userTypeId === 2) {
        navigate("/ulb/login");
      }
    }
  };


  useEffect(() => {
  if (userTypeId === 2) {
    const districtId = localStorage.getItem("districtId");

    if (districtId) {
      fetchCircleList(); // ✅ no subdivision
    }
  }
}, [userTypeId]);





  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    borderTopLeftRadius: "10px",
    backgroundColor: "#edf7fe",
    height: "10px",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
  };

  const getPageNumbers = () => {
    const pages = [];
    const max = 5;

    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + max - 1);

    if (end - start < max - 1) {
      start = Math.max(1, end - max + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  const selectedMunicipalityName =
    userTypeId === 1
      ? municipalityList.find(
          (m) => String(m.user_id) === String(filters.municipality_id),
        )?.name
      : muniName;


//       useEffect(() => {
//   if (userTypeId === 2) {
//     const storedSubdivisionId = localStorage.getItem("districtId");

//     if (storedSubdivisionId) {
//       setFilters((prev) => ({
//         ...prev,
//         subdivision_id: storedSubdivisionId,
//       }));

//       fetchCircleList(storedSubdivisionId);
//     }
//   }
// }, [userTypeId]);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* 🔍 FILTER CARD */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        {/* HEADER */}
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> Report Filters
          </h5>
        </div>

        {/* FILTER BODY */}
        <Card.Body className="px-4 py-4">
          <Row className="align-items-end">
            {userTypeId === 1 && (
  <>
    {/* District */}
    <Col md={3}>
      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">District (Optional)</Form.Label>
        <Form.Select
          value={filters.district_id}
          onChange={handleDistrictChange}
          style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
        >
          <option value="">All Districts</option>
          {districtList.map((d) => (
            <option key={d.id} value={d.id}>
              {d.district_name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col>

    {/* Sub Division */}
    {/* <Col md={3}>
      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Sub Division (Optional)</Form.Label>
        <Form.Select
          value={filters.subdivision_id}
          onChange={(e) => {
            const subId = e.target.value;
            setFilters((prev) => ({
              ...prev,
              subdivision_id: subId,
              circle_id: "",
              school_id: "",
            }));
            fetchCircleList(subId);
            loadSchools();
          }}
          style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
        >
          <option value="">All Sub Divisions</option>
          {subDivisionList.map((s) => (
            <option key={s.id} value={s.id}>
              {s.sub_division_name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col> */}

    {/* Municipality */}
    <Col md={3}>
      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">
          Municipality <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select
          value={filters.municipality_id}
          onChange={(e) => {
            setFilters({
              ...filters,
              municipality_id: e.target.value,
              school_id: "",
            });
            loadSchools();
            setReports([]);
            setPage(1);
            setTotalPages(1);
            setTotalRecords(0);
          }}
          style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
        >
          <option value="">All Municipalities</option>
          {municipalityList.map((m) => (
            <option key={m.user_id} value={m.user_id}>
              {m.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col>
  </>
)}


            {/* <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">
                      Sub Division (Optional)
                    </Form.Label>


                    <Form.Select
   value={filters.subdivision_id}
  onChange={(e) => {
    const subId = e.target.value;

    setFilters((prev) => ({
      ...prev,
      subdivision_id: subId,
      circle_id: "",
      school_id: "",
    }));

    fetchCircleList(subId);
    loadSchools();
  }}
  style={{
    borderRadius: "10px",
    border: "2px solid #1565C1",
  }}
>
  <option value="">All Sub Divisions</option>
  {subDivisionList.map((s) => (
    <option key={s.id} value={s.id}>
      {s.sub_division_name}
    </option>
  ))}
</Form.Select>

                  </Form.Group>
                </Col>

            <Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold">Circle (Optional)</Form.Label>
    <Form.Select
      value={filters.circle_id}
      onChange={(e) => {
    setFilters((prev) => ({ ...prev, circle_id: e.target.value, school_id: "" }));
    loadSchools();
  }}
    //   disabled={!filters.subdivision_id}
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">All Circles</option>
      {circleList.map((c) => (
        <option key={c.id} value={c.id}>
          {c.circle_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col> */}


            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">School (Optional)</Form.Label>
                <Form.Select
                  value={filters.school_id}
disabled={
  userTypeId === 1 &&
  !filters.district_id &&
  !filters.subdivision_id &&
  !filters.circle_id &&
  !filters.municipality_id
}
                  onChange={(e) =>
                    setFilters({ ...filters, school_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">All Schools</option>
                  {schoolList.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Class (Optional)</Form.Label>
                <Form.Select
                  value={filters.class_id}
                  onChange={(e) =>
                    setFilters({ ...filters, class_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">All Classes</option>
                  {classList.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Record Showing (Optional)
                </Form.Label>

                <Form.Select
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);
                  }}
                >
                  <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4} className="d-flex gap-3 mb-3">
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#1565C1",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                onClick={() => {
                  if (userTypeId === 1 && !filters.municipality_id) {
                    Swal.fire({
                      icon: "warning",
                      title: "Municipality Required",
                      text: "Please select a Municipality before searching.",
                      confirmButtonColor: "#1565C1",
                      confirmButtonText: "OK",
                    });
                    return;
                  }

                  loadReports(1);
                }}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#E53935",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                onClick={() => {
                  const resetFilters = {
                    district_id: "",
                    subdivision_id: "",
                    circle_id: "",
                    municipality_id: "",
                    school_id: "",
                    class_id: "",
                  };

                  setFilters(resetFilters);
                  setSubDivisionList([]);
                  setSchoolList([]);
                  setcircleList([]);
                  setReports([]);
                  setPage(1);
                  setPerPage(10);
                  setTotalPages(1);
                  setTotalRecords(0);

                  if (userTypeId !== 1) {
                    loadReports(1, 10, resetFilters);
                  }
                  if (userTypeId === 2) {
    fetchSubDivisions(); // will use districtId from localStorage
  }
                }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {userTypeId === 2 && (
        <div className="text-center mb-4">
          <h4 className="fw-bold text-dark mb-1">{muniName}</h4>
          <div className="fs-6 text-success">
            School-wise Measurement Report (As on {today})
          </div>
        </div>
      )}

      {reports.length > 0 && userTypeId === 1 && filters.municipality_id && municipalityData &&(
        <div className="text-center mb-4">
          <h4 className="fw-bold text-dark mb-1">{selectedMunicipalityName}</h4>
          <div className="fs-6 text-success">
            School-wise Measurement Report (As on {today})

          </div>

          <div
  className="p-4 rounded-4 shadow-sm"

>


  <div className="row text-center">

    <div className="col-md-3 mb-3">
      <div
        className="p-3 rounded-3 shadow-sm"
        style={{ background: "#e3f2fd" }}
      >
        <div className="fw-bold text-primary fs-5">
                        {municipalityData.total_school_count || 0}

        </div>
        <div className="small text-muted">
          Total Schools
        </div>
      </div>
    </div>

    <div className="col-md-3 mb-3">
      <div
        className="p-3 rounded-3 shadow-sm"
        style={{ background: "#fff3e0" }}
      >
        <div className="fw-bold text-warning fs-5">
          {municipalityData.total_class_count || 0}
        </div>
        <div className="small text-muted">
          Total Classes
        </div>
      </div>
    </div>

    <div className="col-md-3 mb-3">
      <div
        className="p-3 rounded-3 shadow-sm"
        style={{ background: "#e8f5e9" }}
      >
        <div className="fw-bold text-success fs-5">
          {municipalityData.total_student_count}
        </div>
        <div className="small text-muted">
          Total Students
        </div>
      </div>
    </div>

    <div className="col-md-3 mb-3">
    <div
      className="p-3 rounded-3 shadow-sm"
      style={{ background: "#f3e5f5" }}
    >
      <div className="fw-bold fs-5" style={{ color: "#6a1b9a" }}>
        {municipalityData.measurements_taken_students_count}
      </div>
      <div className="small text-muted">
        Measurements Taken (Till Date)
      </div>
    </div>
  </div>

  </div>
</div>

        </div>
      )}

      <Card
        className="border-0"
        style={{
          background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
          boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          overflow: "hidden",
        }}
      >
        {loading ? (
          <div className="loader-wrapper">
            <div className="blue-spinner"></div>

            <div className="loading-line">
              <div className="loading-progress"></div>
            </div>

            <p className="loading-text">
              Please Wait... While Gathering Reports
            </p>
          </div>
        ) : (
          <>
            <Table bordered hover responsive striped className="mb-0">
              <thead style={{ background: "#edf7fe" }}>
                <tr>
                  <th style={theadStyle}>SL No</th>
                  <th style={theadStyle}>School</th>
                  {/* <th style={theadStyle}>Location Details</th> */}
                  <th style={theadStyle}>Category</th>
                  <th style={theadStyle}>Management Type</th>
                  <th style={theadStyle}>Type</th>
                  <th style={theadStyle}>Total Student</th>
                  <th style={theadStyle}>Measurement Taken Till Date</th>
                </tr>
              </thead>

              <tbody>
                {reports.length ? (
                  reports.map((r, i) => (
                    <tr key={i}>
                      <td className="text-center">
                        {(page - 1) * perPage + i + 1}
                      </td>

                      <td className="text-center">{r.school_name}</td>
                      {/* <td className="text-start">
                        {userTypeId === 1 && (
  <>
    <div>
      <strong>District :</strong> {r.district_name || "-"}
    </div>
    <div>
      <strong>Municipality :</strong> {r.municipality_name || "-"}
    </div>
  </>
)}

                        <div>
                          <strong>Subdivision :</strong>{" "}
                          {r.sub_division_name || "-"}

                        </div>
                        <div>
                          <strong>Circle Name :</strong>{" "}
                          {r.circle_name || "-"}
                        </div>

                      </td> */}

                      <td className="text-center">{r.category_name}</td>
                                            <td className="text-center">{r.management_name}</td>

                      <td className="text-center">{r.type_name}</td>
                      <td className="text-center">{r.total_student_count}</td>
                      <td className="text-center">
                        {r.measurements_taken_students_count}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-muted py-4">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center my-4">
                <nav>
                  <ul className="pagination shadow-sm">
                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => loadReports(1)}
                      >
                        «
                      </button>
                    </li>

                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => loadReports(page - 1)}
                      >
                        ‹
                      </button>
                    </li>

                    {getPageNumbers().map((p) => (
                      <li
                        key={p}
                        className={`page-item ${page === p ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => loadReports(p)}
                        >
                          {p}
                        </button>
                      </li>
                    ))}

                    <li
                      className={`page-item ${
                        page === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => loadReports(page + 1)}
                      >
                        ›
                      </button>
                    </li>

                    <li
                      className={`page-item ${
                        page === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => loadReports(totalPages)}
                      >
                        »
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
};

export default ReportList;
